// extracted by mini-css-extract-plugin
module.exports = {"body":"styles_body__3Dg3O","loader":"styles_loader__1QxE1","errorContainer":"styles_errorContainer__2jStY"};